/**
 * Public API paths that must not send Okta or Bennie session credentials.
 * Used on unauthenticated routes (e.g. create-account, resend-activation-email).
 */
export const OMITTED_URLS = [
  'v1/tokenAuth',
  'v1/users/credentials',
  'v1/anonymous/users/resendactivationemail',
];

export const isUnauthenticatedUrl = url =>
  url ? OMITTED_URLS.some(omittedUrl => url.includes(omittedUrl)) : false;
